import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaFacebook = props => {
  if (props.id !== "_svgsocialmediafacebook") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><g fill="#333"><path d="M120 15C62.562 15 16 61.562 16 119s46.562 104 104 104 104-46.562 104-104S177.438 15 120 15zm0 196c-50.729 0-92-41.271-92-92s41.271-92 92-92 92 41.271 92 92-41.271 92-92 92z" /><path d="M108.111 89.317v14.684H90.917v19.91h17.193V175h20.562v-51.088h17.148l2.565-19.91H128.67V91.29c0-5.765 1.601-9.693 9.866-9.693l10.544-.005V63.784C147.257 63.542 141 63 133.719 63c-15.202 0-25.608 9.278-25.608 26.317z" /></g></svg>;
};

SvgSocialmediaFacebook.displayName = "_svgsocialmediafacebook";
SvgSocialmediaFacebook.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaFacebook.defaultProps = {
  id: ''
};
export default SvgSocialmediaFacebook;